import { createContext } from 'react';

import { INewbuildingBrokerModalsContext } from './types/newbuildingBrokerModalsContext';

/* istanbul ignore next */
export const NewbuildingBrokerModalsContext = createContext<INewbuildingBrokerModalsContext>({
  isSelfRequestModalLoading: false,
  startMicrofrontOpening: () => {},
});
